import { render, staticRenderFns } from "./TopNavigation.vue?vue&type=template&id=09371063&scoped=true&"
import script from "./TopNavigation.vue?vue&type=script&lang=ts&"
export * from "./TopNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./TopNavigation.vue?vue&type=style&index=0&id=09371063&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09371063",
  null
  
)

export default component.exports